import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { ShowDoc, ViewClass } from "../../MainPage/Tools/Consts";
import { Button as DlgButton } from "../../MainPage/Tools/ProjectX";
import { resumeRequest, type TokenSubData } from "../TokenProcessing";
import HandleTable from "./HandleTable";

const defaultShowDocOptions = ShowDoc.Modal | ShowDoc.Single;

const hasShowDocOption = (options: number, option: ShowDoc) => (options & option) === option;

interface Data {
  json: {
    Params: {
      DocCfgID?: string;
      DocID?: string;
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      Options?: string;
      OnlyView?: string;
      MultiSel?: string;
      Level?: string;
      Code?: string;
      RecordIndex?: string;
      Title?: string;
    };
    CLSID?: string;
    Title?: string;
    Module?: string;
  };
  subData: TokenSubData;
  requestID: string;
}

export const exposeDocument = (data: Data) => {
  const { json, subData, requestID } = data;
  if (json.Params) {
    const parsedOptions = Number(json.Params.Options ?? defaultShowDocOptions);
    const options = Number.isFinite(parsedOptions) ? parsedOptions : defaultShowDocOptions;
    const isModal = hasShowDocOption(options, ShowDoc.Modal);
    const isSingle = hasShowDocOption(options, ShowDoc.Single);
    const isSelecting = hasShowDocOption(options, ShowDoc.Selecting);
    const modalButtons = isSelecting ? DlgButton.Ok | DlgButton.Cancel : DlgButton.Cancel;

    smetaModals.open(
      <HandleTable
        json={{
          ...json.Params,
          CLSID: ViewClass.DocBook,
        }}
        subData={{
          props: {
            ...json.Params,
            Module: json.Module,
            Buttons: isSelecting ? undefined : DlgButton.Cancel,
            SectionID: getModalSectionID(),
            PlaneView: isSingle ? "1" : "0",
            detailsOpen: true,
            func: subData.func,
            from: subData.from,
            // htmlInput: json.jsonData.content,
            // caption: json.Params.Caption,
            // RequestID: json.Params.RequestID,
          },
        }}
      />,
      {
        Title: "Документ",
        style: getStyleWindow(ViewClass.DocBook),
        Buttons: {
          Buttons: modalButtons,
          jsonData: {
            Кнопка$Выбрать: "Выбрать",
            Кнопка$Отмена: "Закрыть",
          },
        },
        disableBlockBackground: !isModal,
        onClose: () => {
          subData.props?.input?.current?.focus();
          resumeRequest(requestID, subData, {});
        },
        callBacks: true,
      },
    );
  }
};
